import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import EventDetail from './EventDetail';
import EventItem from './EventItem';
import EventManager from './EventManager';
import styles from '../../../../components/Display/Wrapper.module.scss';

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState(undefined);
  const [mainTagFilter, setMainTagFilter] = useState(undefined);
  const [showpastEventList, setShowPastEventList] = useState(false);
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchEventList();
  }, [typeFilter, mainTagFilter, showpastEventList]);

  const fetchEventList = async () => {
    await privateFetch(
      'GET',
      'bassecour',
      `/cu/${accountContext.id}/event/?type=${typeFilter || ''}&main_tag=${mainTagFilter || ''}&date=${showpastEventList && 'past'}`
    ).then((res) => {
      setEventList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
  }, [navigationContext]);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'bassecour',
      `/cu/${accountContext.id}/event/${navigationContext.activeEventId}/`
    ).then((res) => {
      if (res) setEventDetail(res);
    });
  };

  const handleClickEvent = (event) => {
    setActiveView('bacevent', event, 'activeEventId');
  };

  useEffect(() => {
    if (panelIsOpen === false) {
      setDuplicationMode(false) && setEventDetail(undefined);
    }
  }, [panelIsOpen]);

  const handleDuplicateEvent = (event) => {
    handleOpenManager();
    setDuplicationMode(true);
    handleClickEvent(event);
  };

  useEffect(() => {
    if (navigationContext.activeEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const goBackEventAction = {
    onClick: handleClickEvent,
    label: 'Retour à la liste',
    icon: 'pi pi-arrow-left'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évènement',
    icon: 'pi-plus'
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'bassecour',
      `/cu/${accountContext.id}/event/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
      setDuplicationMode(false);
      setEventDetail(undefined);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'bassecour',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'bassecour',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évènement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == 'grid' ? 'pi-list' : 'pi-th-large'
  };

  const eventFilters = (
    <div className={styles.filterList}>
      <SelectButton
        value={showpastEventList}
        onChange={(e) => setShowPastEventList(e.value)}
        options={CONSTANT.bassecour.selectButtonOptions}
        className={styles.switchButton}
      />

      <Dropdown
        value={typeFilter}
        options={CONSTANT.bassecour.type}
        optionLabel="label"
        onChange={(e) => setTypeFilter(e.value)}
        placeholder="Filtrer par Type"
        className={styles.switchButton}
        filter
        showClear
      />

      <Dropdown
        value={mainTagFilter}
        options={CONSTANT.bassecour.main_tag}
        optionLabel="label"
        onChange={(e) => setMainTagFilter(e.value)}
        placeholder="Filtrer par Public"
        className={styles.switchButton}
        filter
        showClear
      />
    </div>
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Événements"
        labelAction={handleClickEvent}
        actions={eventDetail ? [goBackEventAction] : [changeLayoutAction, newEventAction]}
        detail={eventDetail}>
        {eventDetail && !duplicationMode ? (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleDelete={deleteEvent}
          />
        ) : (
          <>
            {eventFilters}
            <div className={styles.pageContentContainer}>
              <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
                {eventList.map((event, index) => (
                  <EventItem
                    layout={layout}
                    key={index}
                    event={event}
                    handleClickEvent={() => handleClickEvent(event)}
                    handleDuplicateEvent={() => handleDuplicateEvent(event)}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </PageWrapper>
      <EventManager
        isOpen={panelIsOpen}
        onClose={() => {
          setDuplicationMode(false);
          setPanelIsOpen(false);
        }}
        event={eventDetail}
        onCreate={createEvent}
        onUpdate={updateEvent}
        loading={loading}
        duplicationMode={duplicationMode}
        setPanelIsOpen={setPanelIsOpen}
        setEventDetail={setEventDetail}
      />
    </div>
  );
}

export default EventPage;
